import { CustomerShippingAddress } from '../../backend/openapi/api-types';
import { notNil } from '../../../core/helpers/is-nil';

export function selectDeliveryAddress(
  shippingAddresses: CustomerShippingAddress[] | undefined,
  storedAddressId: string | null,
) {
  if (!shippingAddresses) {
    return null;
  }

  const storedAddress = shippingAddresses.find((address) => address.addressId === storedAddressId);
  if (notNil(storedAddress) && notNil(storedAddressId)) {
    return storedAddress;
  }

  const defaultAddress = shippingAddresses.find((address) => address.isDefault);
  if (notNil(defaultAddress)) {
    return defaultAddress;
  }

  const firstAddress = shippingAddresses[0];
  if (notNil(firstAddress)) {
    return firstAddress;
  }

  return null;
}
